import { SortColumnDto } from '@asset-metrix/portal-gateway-client-js';
import { StateCreator } from 'zustand';

import { RemoveFunctions } from '../../utils/types';
import { StateSlices } from '..';

export type TableSortColumnsSlice = {
  sortColumns: Partial<{
    [pageFilterInstanceId: string]: Partial<{
      [widgetFilterInstanceId: string]: SortColumnDto[];
    }>;
  }>;
  setSortColumns: (
    pageFilterInstanceId: string,
    widgetFilterInstanceId: string,
    columns: SortColumnDto[]
  ) => void;
  cloneSortColumns: (
    pageFilterInstanceIdFrom: string,
    widgetFilterInstanceIdFrom: string,
    pageFilterInstanceIdTo: string,
    widgetFilterInstanceIdTo: string
  ) => void;
  deleteSortColumns: (
    pageFilterInstanceId: string,
    widgetFilterInstanceId: string
  ) => void;
};

const initialState: RemoveFunctions<TableSortColumnsSlice> = {
  sortColumns: {},
};

export const createTableSortColumnsSlice: StateCreator<
  StateSlices,
  [],
  [],
  TableSortColumnsSlice
> = (set) => {
  return {
    ...initialState,
    setSortColumns(
      pageFilterInstanceId: string,
      widgetFilterInstanceId: string,
      columns: SortColumnDto[]
    ) {
      set((state) => {
        return {
          sortColumns: {
            ...state.sortColumns,
            [pageFilterInstanceId]: {
              ...state.sortColumns[pageFilterInstanceId],
              [widgetFilterInstanceId]: columns,
            },
          },
        };
      });
    },
    cloneSortColumns(
      pageFilterInstanceIdFrom,
      widgetFilterInstanceIdFrom,
      pageFilterInstanceIdTo,
      widgetFilterInstanceIdTo
    ) {
      set((state) => {
        const columns =
          state.sortColumns[pageFilterInstanceIdFrom]?.[
            widgetFilterInstanceIdFrom
          ];
        if (columns == null) {
          return state;
        }

        return {
          sortColumns: {
            ...state.sortColumns,
            [pageFilterInstanceIdTo]: {
              ...state.sortColumns[pageFilterInstanceIdTo],
              [widgetFilterInstanceIdTo]: [...columns],
            },
          },
        };
      });
    },
    deleteSortColumns(pageFilterInstanceId, widgetFilterInstanceId) {
      set((state) => {
        const pageSortColumns = state.sortColumns[pageFilterInstanceId];
        if (pageSortColumns?.[widgetFilterInstanceId] == null) {
          return state;
        }

        const { [widgetFilterInstanceId]: _, ...remainingWidgetSortColumns } =
          pageSortColumns;

        return {
          sortColumns: {
            ...state.sortColumns,
            [pageFilterInstanceId]: remainingWidgetSortColumns,
          },
        };
      });
    },
  };
};
